import styled from 'styled-components'
import { Modal } from 'semantic-ui-react'

export const FilterModalContent = styled.div`
  .applied-filters {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
  }

  .add-filter-container {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 100%;
  }

  .no-available-filters {
    text-align: center;
    color: #999;
    padding: 1em 0;
    font-style: italic;
  }

  .filter-info-hint {
    color: #999;
    font-size: 0.9em;
    font-style: italic;
  }
`

export const FilterChip = styled.li`
  display: inline-block;
  margin: 0 0.5em 8px 0;
  border: 1px solid #dedede;
  background-color: #f4f4f4;
  padding: 0.3em 1em 0.5em 0.7em;

  strong {
    margin-right: 0.3em;
  }

  .remove-icon {
    margin: 0.2em 0 0 0.3em;
    padding: 0 0.3em;
    color: #999;
    cursor: pointer;

    &:hover {
      color: var(--red);
    }
  }
`

export const NoFiltersMessage = styled.div`
  color: rgb(130, 130, 130);
  text-align: center;
  padding: 0.5em 0;
`

export const FilterTriggerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.7rem 0.3rem;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--sidebar-text-color);
  font-size: inherit;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: var(--sidebar-hover-bg);
  }

  &.has-filters {
    color: var(--green);
    font-weight: 800;

    i.icon {
      color: var(--green);
    }
  }

  i.icon {
    margin-right: 0;
  }
`

export const StyledModalActions = styled(Modal.Actions)`
  display: flex !important;
  justify-content: ${({ $hasFilters }) =>
    $hasFilters ? 'space-between' : 'flex-start'};
`
